<!--New code GG-->
<div style="padding: 2%;">
  

  <div class="panel" style="padding: 1%;">
    <div class="panel__header" style="padding: 0px;">
      <div class="header__title-container">
                  <span class="panel__header__title">{{'Selection Criteria for Filtering'| translate | async}}</span>
              </div>
              <div class="panel__header__buttons flex-container row" style="margin-right: 2%;">
  
                <div class="fav-divider"></div>
                  <a class="button" >
                      <i class="material-icons button__icon">favorite</i>
                      <span class="button__text">{{'Create Favourite' | translate | async}}</span>
                  </a>
                </div>
  
      </div>
    <div class="search-options"
      style="    min-width: 150px;width: 100%;display: flex;justify-content: space-between;flex-wrap: wrap;padding: 2%;">




      <mat-form-field class="header-form-full-width">
        <mat-select (selectionChange)="jobsiteChanged($event)" id="select-jobsite" placeholder="{{'Select Job Site' | translate | async}}"
          [(ngModel)]="selectedJobsite" name="jobsite" [formControl]="jobsite" ngDefaultControl required>
          <mat-option *ngFor="let jobsite of _dropDownLists.jobSiteList" [value]="jobsite">
            {{ jobsite.Title }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="jobsite.invalid">{{getErrorMessage()}}</mat-error>
      </mat-form-field>

      <mat-form-field class="header-form-full-width">
        <mat-select id="select-model" placeholder="{{'Select Model' | translate | async}}" [(ngModel)]="selectedModel" name="modelid"
          [formControl]="modelid" ngDefaultControl required (selectionChange)="GetSerialbyModelFamilyMake()">
          <mat-option [value]="model.Id" *ngFor="let model of modelList">
            {{model.Name}}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="modelid.invalid">{{getModelErrorMessage()}}</mat-error>
      </mat-form-field>

      

      <mat-form-field class="header-form-full-width">
        <mat-select [(value)]="selectedMake" name="make" placeholder="{{'Select Brand' | translate | async}}" [(ngModel)]="selectedMake"
          ngDefaultControl>
          <mat-option>None</mat-option>
          <mat-option *ngFor="let make of _dropDownLists.makeList" [value]="make.Id">
            {{ make.Title }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="header-form-full-width">
        <mat-select id="select-equipment-serialno" placeholder="{{'Select Unit Number' | translate | async}}" [(ngModel)]="selectedEquipment"
          ngDefaultControl>
          <mat-option [value]="equipment.Id" *ngFor="let equipment of equipmentList">
            {{equipment.UnitNumber}}||{{equipment.SerialNumber}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="header-form-full-width">
        <mat-select id="select-component-type" placeholder="{{'Select Component Type' | translate | async}}"
          [(ngModel)]="selectedComponentType"  ngDefaultControl>
          <mat-option [value]="compType.comTypeAuto" *ngFor="let compType of componenttypesList">
            {{compType.comTypeName}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="header-form-full-width">
        <mat-select id="select-side" placeholder="{{'Select Side' | translate | async}}"  ngDefaultControl>
          <mat-option [value]="1"> {{'Left' | translate | async}} </mat-option>
          <mat-option [value]="2"> {{'Right' | translate | async}} </mat-option>
        </mat-select>
      </mat-form-field>

      <div  class="header-form-full-width" style="display: flex;flex-direction: row;;width: 30%;">
        <span style="width: 21%; text-align: -webkit-left;place-self: center;">{{'Dates' | translate | async}}</span>
        <mat-form-field >
          <input matInput [matDatepicker]="startDatePicker" placeholder="{{'Start Date'|translate | async}}" 
            [(ngModel)]="startDate" ngDefaultControl>
          <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #startDatePicker></mat-datepicker>
        </mat-form-field>
      
        <mat-form-field >
          <input matInput [matDatepicker]="endDatePicker" placeholder="{{'End Date'|translate|async}}"  
            [(ngModel)]="endDate" ngDefaultControl>
          <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #endDatePicker></mat-datepicker>
        </mat-form-field>
      </div>



      <mat-form-field class="header-form-full-width">
        <mat-select id="select-month" placeholder="{{'Select Year' | translate | async}}" [(ngModel)]="selectedYear" ngDefaultControl>
          <mat-option [value]="2017"> 2017 </mat-option>
          <mat-option [value]="2018"> 2018 </mat-option>
          <mat-option [value]="2019"> 2019 </mat-option>
          <mat-option [value]="2020"> 2020 </mat-option>
          <mat-option [value]="2021"> 2021 </mat-option>
          <mat-option [value]="2022"> 2022 </mat-option>
          <mat-option [value]="2022"> 2023 </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="header-form-full-width">
        <mat-select id="select-month" placeholder="{{'Select Month' | translate | async}}" [(ngModel)]="selectedMonth" ngDefaultControl>
          <mat-option [value]="1">  {{'Jan' | translate | async}} </mat-option>
          <mat-option [value]="2">  {{'Feb' | translate | async}} </mat-option>
          <mat-option [value]="3">  {{'Mar' | translate | async}} </mat-option>
          <mat-option [value]="4">  {{'Apr' | translate | async}} </mat-option>
          <mat-option [value]="5">  {{'May' | translate | async}} </mat-option>
          <mat-option [value]="6">  {{'Jun' | translate | async}} </mat-option>
          <mat-option [value]="7">  {{'Jul' | translate | async}} </mat-option>
          <mat-option [value]="8">  {{'Aug' | translate | async}} </mat-option>
          <mat-option [value]="9">  {{'Sep' | translate | async}} </mat-option>
          <mat-option [value]="10"> {{'Oct' | translate | async}} </mat-option>
          <mat-option [value]="11"> {{'Nov' | translate | async}} </mat-option>
          <mat-option [value]="12"> {{'Dec' | translate | async}} </mat-option>
        </mat-select>
      </mat-form-field>

      <div  class="header-form-full-width" style="display: flex;flex-direction: row;;width: 30%;">
        <span style="width: 21%; text-align: -webkit-left;place-self: center;">SMU</span>
        <mat-form-field style="width: 39%;">
          <input matInput type="number" placeholder="{{'Start SMU'|translate | async}}" [(ngModel)]="startSMU"
            ngDefaultControl>
        </mat-form-field>
  
        <mat-form-field style="width: 39%;">
          <input matInput type="number" placeholder="{{'End SMU'|translate | async}}" [(ngModel)]="endSMU"
            ngDefaultControl>
        </mat-form-field>
      </div>

      <div  class="header-form-full-width" style="display: flex;flex-direction: row;;width: 30%;">
        <span style="width: 21%; text-align: -webkit-left;place-self: center;">CMU</span>
        <mat-form-field style="width: 39%;">
          <input matInput type="number" placeholder="{{'Start CMU'|translate | async}}" [(ngModel)]="startCMU"
            ngDefaultControl>
        </mat-form-field>
  
        <mat-form-field style="width: 39%;">
          <input matInput type="number" placeholder="{{'End CMU'|translate | async}}" [(ngModel)]="endCMU"
            ngDefaultControl>
        </mat-form-field>
      </div>
      
      <div  class="header-form-full-width" style="display: flex;flex-direction: row;;width: 30%;">
        <span style="width: 21%; text-align: -webkit-left;place-self: center;">{{'Distance' | translate | async}}</span>
        <mat-form-field style="width: 39%;">
          <input matInput type="number" placeholder="{{'Start Dist'|translate | async}}" [(ngModel)]="startDistance"
            ngDefaultControl>
        </mat-form-field>
  
        <mat-form-field style="width: 39%;">
          <input matInput type="number" placeholder="{{'End Dist'|translate | async}}" [(ngModel)]="endDistance"
            ngDefaultControl>
        </mat-form-field>
      </div>
        

      

      

      

     


    

   

      <div class="bottom-row" style="    flex-direction: row-reverse;">

        <div class="flex flex--align-center">
          <a class="button" (click)="resetFields();"><span class="button__text">{{'Reset' | translate | async}}</span></a>
          <a class="button button--primary" (click)="submitSelection()"><i
              class="material-icons button__icon">search</i><span class="button__text">{{'Search' | translate | async}}</span></a>
        </div>
      </div>


    </div>
  </div>
</div>
<!--End New Code GG-->




<section class="filter-area">







  <!-- <div class="first_section" style="margin-top: 4rem">
    <div class="filter_head">
      <p><strong>Selection Criteria for Filtering</strong></p>
      <button class="btn btn-create">Create Favourite</button>
    </div>
    <div class="row">
      <div class="col-md-8">
        <div class="row">
          <div class="col-md-3">
            <mat-form-field class="header-form-full-width">
              <span class="label">Select Job Site</span>
              <mat-select (selectionChange)="jobsiteChanged($event)" id="select-jobsite" placeholder="Select Job Site"
                [(ngModel)]="selectedJobsite" name="jobsite" [formControl]="jobsite" ngDefaultControl required>
                <mat-option *ngFor="let jobsite of _dropDownLists.jobSiteList" [value]="jobsite">
                  {{ jobsite.Title }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="jobsite.invalid">{{getErrorMessage()}}</mat-error>
            </mat-form-field>
          </div>
          <div class="col-md-3">
            <mat-form-field class="header-form-full-width">
              <span class="label">Select Model</span>
              <mat-select id="select-model" placeholder="Select Model" [(ngModel)]="selectedModel" name="modelid"
                [formControl]="modelid" ngDefaultControl required (change)="GetSerialbyModelFamilyMake()">
                <mat-option [value]="model.Id" *ngFor="let model of modelList">
                  {{model.Name}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="modelid.invalid">{{getModelErrorMessage()}}</mat-error>
            </mat-form-field>
          </div>
          <div class="col-md-3">
            <mat-form-field class="header-form-full-width">
              <span class="label"> Select Unit</span>
              <mat-select id="select-equipment-serialno" placeholder="Select Unit" [(ngModel)]="selectedEquipment"
                ngDefaultControl>
                <mat-option [value]="equipment.Id" *ngFor="let equipment of equipmentList">
                  {{equipment.UnitNumber}}||{{equipment.SerialNumber}}
                </mat-option>
              </mat-select>
            </mat-form-field> 
          </div>
          <div class="col-md-3">
            <mat-form-field class="header-form-full-width">
              <span class="label">Start Date</span>
              <input matInput [matDatepicker]="startDatePicker" placeholder="{{'Start Date'|translate | async}}"
                [(ngModel)]="startDate" ngDefaultControl>
              <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #startDatePicker></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="col-md-3">
            <mat-form-field class="header-form-full-width">
              <span class="label">End Date</span>
              <input matInput [matDatepicker]="endDatePicker" placeholder="{{'End Date'|translate|async}}"
                [(ngModel)]="endDate" ngDefaultControl>
              <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #endDatePicker></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="col-md-3">
            <mat-form-field class="header-form-full-width">
              <span class="label">Start SMU</span>
              <input matInput type="number" placeholder="{{'Start SMU'|translate | async}}" [(ngModel)]="startSMU"
                ngDefaultControl>
            </mat-form-field>
          </div>
          <div class="col-md-3">
            <mat-form-field class="header-form-full-width">
              <span class="label">End SMU</span>
              <input matInput type="number" placeholder="{{'End SMU'|translate | async}}" [(ngModel)]="endSMU"
                ngDefaultControl>
            </mat-form-field>
          </div>
          <div class="col-md-3">
            <mat-form-field class="header-form-full-width">
              <span class="label">Start CMU</span>
              <input matInput type="number" placeholder="{{'Start CMU'|translate | async}}" [(ngModel)]="startCMU"
                ngDefaultControl>
            </mat-form-field>
          </div>
          <div class="col-md-3">
            <mat-form-field class="header-form-full-width">
              <span class="label">End CMU</span>
              <input matInput type="number" placeholder="{{'End CMU'|translate | async}}" [(ngModel)]="endCMU"
                ngDefaultControl>
            </mat-form-field>
          </div>
          <div class="col-md-3">
            <mat-form-field class="header-form-full-width">
              <span class="label">Start Dist</span>
              <input matInput type="number" placeholder="{{'Start Dist'|translate | async}}" [(ngModel)]="startDistance"
                ngDefaultControl>
            </mat-form-field>
          </div>
          <div class="col-md-3">
            <mat-form-field class="header-form-full-width">
              <span class="label">End Dist</span>
              <input matInput type="number" placeholder="{{'End Dist'|translate | async}}" [(ngModel)]="endDistance"
                ngDefaultControl>
            </mat-form-field>
          </div>
          <div class="col-md-3">
            <mat-form-field class="header-form-full-width">
              <span class="label">Month</span>
              <mat-select id="select-month" placeholder="Select Month" [(ngModel)]="selectedMonth"
                style="margin-bottom: 10px;" ngDefaultControl>
                <mat-option [value]="1"> Jan </mat-option>
                <mat-option [value]="2"> Feb </mat-option>
                <mat-option [value]="3"> Mar </mat-option>
                <mat-option [value]="4"> Apr </mat-option>
                <mat-option [value]="5"> May </mat-option>
                <mat-option [value]="6"> Jun </mat-option>
                <mat-option [value]="7"> Jul </mat-option>
                <mat-option [value]="8"> Aug </mat-option>
                <mat-option [value]="9"> Sep </mat-option>
                <mat-option [value]="10"> Oct </mat-option>
                <mat-option [value]="11"> Nov </mat-option>
                <mat-option [value]="12"> Dec </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="row">
          <div class="col-md-6">
            <mat-form-field class="header-form-full-width">
              <span class="label">Component Type</span>
              <mat-select id="select-component-type" placeholder="Select Component Type"
                [(ngModel)]="selectedComponentType" style="margin-bottom: 10px;" ngDefaultControl>
                <mat-option [value]="compType.comTypeAuto" *ngFor="let compType of componenttypesList">
                  {{compType.comTypeName}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-6">
            <mat-form-field class="header-form-full-width">
              <mat-select [(value)]="selectedMake" name="make" placeholder="Select Brand" [(ngModel)]="selectedMake"
                ngDefaultControl>
                <mat-option>None</mat-option>
                <mat-option *ngFor="let make of _dropDownLists.makeList" [value]="make.Id">
                  {{ make.Title }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-6">
            <mat-form-field class="header-form-full-width">
              <span class="label">Year</span>
              <mat-select id="select-month" placeholder="Select Year" [(ngModel)]="selectedYear"
                style="margin-bottom: 10px;" ngDefaultControl>
                <mat-option [value]="2017"> 2017 </mat-option>
                <mat-option [value]="2018"> 2018 </mat-option>
                <mat-option [value]="2019"> 2019 </mat-option>
                <mat-option [value]="2020"> 2020 </mat-option>
                <mat-option [value]="2021"> 2021 </mat-option>
                <mat-option [value]="2022"> 2022 </mat-option>
                <mat-option [value]="2022"> 2023 </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-6">
            <mat-form-field class="header-form-full-width">
              <span class="label">Side</span>
              <mat-select id="select-side" placeholder="Select Side" style="margin-bottom: 10px;" ngDefaultControl>
                <mat-option [value]="1"> Left </mat-option>
                <mat-option [value]="2"> Right </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="flex flex--align-center">
          <a class="button" (click)="resetFields();"><span class="button__text">Reset</span></a>
          <a class="button button--primary" (click)="submitSelection()"><i
              class="material-icons button__icon">search</i><span class="button__text">Perform Search</span></a>
        </div>
      </div>
    </div>
  </div> -->








  <div class="second-section">
    <p><strong>{{'Show and hide columns' | translate | async}}</strong></p>
    <div class="checkbox-flex">
      <!-- <div><mat-checkbox [checked]="Site">Site</mat-checkbox></div>
    <div><mat-checkbox [checked]="Serial">S#</mat-checkbox></div>
    <div><mat-checkbox [checked]="Unit">Unit#</mat-checkbox></div>
    <div><mat-checkbox [checked]="Model">Model</mat-checkbox></div>
    <div><mat-checkbox [checked]="Distance">Distance</mat-checkbox></div>
    <div><mat-checkbox [checked]="Season">Season</mat-checkbox></div>
    <div><mat-checkbox [checked]="Brand">Brand</mat-checkbox></div>
    <div><mat-checkbox [checked]="Hrs">Hrs%</mat-checkbox></div>
    <div><mat-checkbox [checked]="M">M%</mat-checkbox></div>
    <div><mat-checkbox [checked]="Hrsmm">Hrs/mm</mat-checkbox></div>
    <div><mat-checkbox [checked]="Distmm">Dist/mm</mat-checkbox></div>
    <div><mat-checkbox [checked]="Segments">Segments</mat-checkbox></div>
    <div><mat-checkbox [checked]="Bushing">Bushing</mat-checkbox></div>
    <div><mat-checkbox [checked]="Links">Links</mat-checkbox></div>
    <div><mat-checkbox [checked]="UR1">UR1</mat-checkbox></div>
    <div><mat-checkbox [checked]="UR2">UR2</mat-checkbox></div>
    <div><mat-checkbox [checked]="UR3">UR3</mat-checkbox></div>
    <div><mat-checkbox [checked]="LR1">LR1</mat-checkbox></div>
    <div><mat-checkbox [checked]="LR2">LR2</mat-checkbox></div>
    <div><mat-checkbox [checked]="LR3">LR3</mat-checkbox></div>
    <div><mat-checkbox [checked]="LR4">LR4</mat-checkbox></div>
    <div><mat-checkbox [checked]="LR5">LR5</mat-checkbox></div>
    <div><mat-checkbox [checked]="LR6">LR6</mat-checkbox></div>
    <div><mat-checkbox [checked]="LR7">LR7</mat-checkbox></div>
    <div><mat-checkbox [checked]="LR8">LR8</mat-checkbox></div> -->
    </div>
  </div>
  <div class="third-section">
    <div class="row">
      <div class="col-md-3">
        <p><strong>{{'Saved Scenarios for Forecasting' | translate | async}}</strong></p>
        <div class="table-responsive">
          <table class="table table-bordered">
            <thead>
              <tr>
                <th>{{'Site' | translate | async}}</th>
                <th>{{'Model' | translate | async}}</th>
                <th>{{'Comment' | translate | async}}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{jobSiteName}}</td>
                <td>{{modelName}}</td>
                <td><input type="text" class="form-control" /></td>
              </tr>
              <!-- <tr>
              <td>Site 1</td>
              <td>Model 1</td>
              <td><input type="text" class="form-control" /></td>
            </tr>
            <tr>
              <td>Site 1</td>
              <td>Model 1</td>
              <td><input type="text" class="form-control" /></td>
            </tr> -->
            </tbody>
          </table>
        </div>
      </div>
      <div class="col-md-6">
        <div class="table-list m-t-3">
          <div class="table-column">
            <div class="table-responsive">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th colspan="8" class="text-center">{{'Segments' | translate | async}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td colspan="4" class="text-center">L</td>
                    <td colspan="4" class="text-center">R</td>
                  </tr>
                  <tr>
                    <td>Hrs%</td>
                    <td>Dist</td>
                    <td>Hrs/mm</td>
                    <td>Dist/mm</td>
                    <td>Hrs%</td>
                    <td>Dist</td>
                    <td>Hrs/mm</td>
                    <td>Dist/mm</td>
                  </tr>
                  <tr>
                    <td>66.6</td>
                    <td>77.7</td>
                    <td>44.4</td>
                    <td>55.5</td>
                    <td>22.2</td>
                    <td>88.8</td>
                    <td>66.6</td>
                    <td>99.9</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="fourth-section">
    <div class="row">
      <div class="col-md-2">
        <p class="m-t-3"><strong>{{'Averages for selected data' | translate | async}}</strong></p>
      </div>
      <div class="col-md-1">
        <mat-form-field style="width: 130px;padding-top: 1.25em;">
          <mat-select placeholder="Scenario" [(ngModel)]="inputValueScenario" name="scenarioinput"
            [formControl]="scenarioinput" required>
            <mat-option value="A">A</mat-option>
            <mat-option value="B">B</mat-option>
            <mat-option value="C">C</mat-option>
          </mat-select>
          <mat-error *ngIf="scenarioinput.invalid">{{getScenarioErrorMessage()}}</mat-error>
        </mat-form-field>
      </div>
      <div class="col-md-1">
        <button (click)="saveUpdateScenario()" class="button button--primary btn-block m-t-3">{{'Update Selection' | translate | async}}</button>
      </div>
      <div class="col-md-1">
        <button (click)="exportexcel()" class="btn btn-block btn-create m-t-3">{{'export' | translate | async}}</button>
      </div>
      <div class="col-md-7">
        <div class="table-list m-t-3">
          <div class="table-column" *ngFor="let data of ComponentStatisticsResult">
            <div class="table-responsive">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th colspan="8" class="text-center">{{data.ComponentType}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td colspan="4" class="text-center">L</td>
                    <td colspan="4" class="text-center">R</td>
                  </tr>
                  <tr>
                    <td>Hrs%</td>
                    <td>Dist%</td>
                    <td>Hrs/mm</td>
                    <td>Dist/mm</td>
                    <td>Hrs%</td>
                    <td>Dist%</td>
                    <td>Hrs/mm</td>
                    <td>Dist/mm</td>
                  </tr>
                  <tr>
                    <td>{{data.HourPercentageAverage}}</td>
                    <td>{{data.DistancePercentageAverage}}</td>
                    <td>{{data.HourWearAverage}}</td>
                    <td>{{data.DistanceWearAverage}}</td>
                    <td>{{data.HourPercentageAverageRight}}</td>
                    <td>{{data.DistancePercentageAverageRight}}</td>
                    <td>{{data.HourWearAverageRight}}</td>
                    <td>{{data.DistanceWearAverageRight}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="fifth-section">
    <div style="margin-left: 39%;" *ngIf="loading">
      <mat-spinner> </mat-spinner>
    </div>
    <div class="row" id="export-data">
      <div class="col-md-4">
        <p><strong>{{'Machine Inspection Data' | translate | async}}</strong></p>
        <div class="table-responsive">
          <table class="table table-bordered">
            <thead>
              <tr>
                <th></th>
                <th>{{'Site' | translate | async}}</th>
                <th>S#</th>
                <th>{{'Unit#' | translate | async}}</th>
                <th>{{'Model' | translate | async}}</th>
                <th>{{'Inpection Date' | translate | async}}</th>
                <th>SMU</th>
                <th>{{'Distance' | translate | async}}</th>
                <th>{{'Average Daily Hrs' | translate | async}}</th>
                <th>{{'Average Daily Dist' | translate | async}}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let machine of MachineInspectionResult">
                <td>
                  <mat-checkbox [checked]="machine.MachineInspectionId"></mat-checkbox>
                </td>
                <td>{{machine.JobSiteName}}</td>
                <td>{{machine.SerialNumber}}</td>
                <td>{{machine.UnitNumber}}</td>
                <td>{{machine.ModelId}}</td>
                <td>{{machine.InspectionDate}}</td>
                <td>{{machine.SMU}}</td>
                <td>{{machine.Distance}}</td>
                <td>{{machine.AverageDailyHours}}</td>
                <td>{{machine.AverageDailyDistance}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="col-md-8">
        <div class="table-list m-t-3">
          <div class="table-column" *ngFor="let data of ComponentStatisticsResult">
            <div class="table-responsive">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th colspan="18" class="text-center">{{data.ComponentType}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td colspan="9" class="text-center">L</td>
                    <td colspan="9" class="text-center">R</td>
                  </tr>
                  <tr>
                    <td>{{'Brand' | translate | async}}</td>
                    <td>%</td>
                    <td>{{'Wear' | translate | async}}</td>
                    <td>CMU</td>
                    <td>Dist</td>
                    <td>Hrs%</td>
                    <td>M%</td>
                    <td>Hrs/mm</td>
                    <td>Dist/mm</td>
                    <td>Brand</td>
                    <td>%</td>
                    <td>Wear</td>
                    <td>CMU</td>
                    <td>Dist</td>
                    <td>Hrs%</td>
                    <td>M%</td>
                    <td>Hrs/mm</td>
                    <td>Dist/mm</td>
                  </tr>
                  <tr *ngFor="let stats of data.ComponentStatisticsStatsList">
                    <td>{{stats.BrandID}}</td>
                    <td>{{stats.WornPercentage}}</td>
                    <td>{{stats.Wear}}</td>
                    <td>{{stats.StartSmu}}</td>
                    <td>{{stats.ComponentDistance}}</td>
                    <td>{{stats.HourPercentage}}</td>
                    <td>{{stats.DistancePercentage}}</td>
                    <td>{{stats.HourWear}}</td>
                    <td>{{stats.DistanceWear}}</td>
                    <td>{{stats.BrandIDRight}}</td>
                    <td>{{stats.WornPercentageRight}}</td>
                    <td>{{stats.WearRight}}</td>
                    <td>{{stats.StartSmuRight}}</td>
                    <td>{{stats.ComponentDistanceRight}}</td>
                    <td>{{stats.HourPercentageRight}}</td>
                    <td>{{stats.DistancePercentageRight}}</td>
                    <td>{{stats.HourWearRight}}</td>
                    <td>{{stats.DistanceWearRight}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</section>